module.exports = __webpack_public_path__ + "static/media/Thumbnail_Vismita.15cffbd3.png";